// extracted by mini-css-extract-plugin
export default {"overviewVars":"Overview_dark_overviewVars__A9Mes"};